import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      ordersViewOuterContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 24px 0px 24px',
        minWidth: '100%',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column'
      },
      ordersViewInnerContainer: {
        background: 'white',
        color: '#2A2A2A',
        minWidth: '100%',
        borderRadius: '8px',
        height: '805px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: '56px 112px 56px 112px',
        margin: '0px 0px 32px 0px',
        [theme.breakpoints.down('lg')]: {
          height: '1640px',
          padding: '48px 24px 56px 24px'
        }
      },
      ordersViewSubHeading: {
        [theme.breakpoints.down('lg')]: {
          paddingBottom: '24px'
        }
      },
      ordersViewCheckbox: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        marginLeft: '0px'
      },
      ordersViewCheckboxCell: {
        flex: '0 0 180px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 120px'
        },
        [theme.breakpoints.only('lg')]: {
          flex: '0 0 120px'
        }
      },
      tableContainer: {
        width: 'calc(100% - 10px)',
        margin: '0 5px 40px'
      },
      tableHeadCell: {
        fontFamily: props.fontFamily,
        fontWeight: 600,
        lineHeight: 1.13,
        whiteSpace: 'nowrap',
        flex: '1',
        background: 'rgb(255, 255, 255)',
        fontSize: '22px',
        border: 0,
        '&:first-child': {
          marginLeft: '10px'
        }
      },
      tableHeadCellCheckBox: {
        fontWeight: 600,
        lineHeight: 1.13,
        whiteSpace: 'nowrap',
        background: 'rgb(255, 255, 255)',
        fontSize: '22px',
        border: 0,
        flex: '0 0 205px',
        '&:first-child': {
          marginLeft: '0px'
        }
      },
      tableBodyCell: {
        whiteSpace: 'nowrap',
        overflowWrap: 'anywhere',
        background: '#ffffff00',
        flex: '1',
        fontSize: '22px',
        border: 0,
        '&:first-child': {
          marginLeft: '0px'
        }
      },
      tableBodyCellCheckBox: {
        whiteSpace: 'nowrap',
        overflowWrap: 'anywhere',
        background: '#ffffff00',
        fontSize: '22px',
        border: 0,
        textAlign: 'center',
        '&:first-child': {
          marginLeft: '0px'
        }
      },
      cartCollapseCell: {
        flex: '0 0 80px',
        '&.MuiTableCell-head': {
          flex: '0 0 55px',
          [theme.breakpoints.down('lg')]: {
            flex: '0 0 5px'
          }
        },
        [theme.breakpoints.down('lg')]: {
          padding: '5px',
          flex: '0 0 85px'
        }
      },
      cartCollapseSubCell: {
        flex: '0 0 80px',
        [theme.breakpoints.down('lg')]: {
          display: 'none'
        },
        [theme.breakpoints.only('lg')]: {
          display: 'none'
        }
      },
      cartTicketCell: {
        flex: '0 0 400px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 200px'
        },
        [theme.breakpoints.only('lg')]: {
          flex: '0 0 300px'
        }
      },
      cartItemCell: {
        flex: '0 0 450px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 250px'
        },
        [theme.breakpoints.only('lg')]: {
          flex: '0 0 300px'
        }
      },
      tableHeadRows: {
        display: 'flex',
        alignItems: 'center',
        border: 0,
        width: '100%',
        padding: '10px 0px',
        borderRadius: '8px',
        backgroundColor: '#fff'
      },
      tableRows: {
        display: 'flex',
        alignItems: 'center',
        border: 0,
        width: '100%',
        padding: '0px',
        borderRadius: '8px',
        boxShadow: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
        backgroundColor: '#fff'
      },
      tableSubRows: {
        display: 'flex',
        width: '100%',
        background: 'rgb(239 239 239 / 50%)',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        borderTop: 0,
        marginBottom: '20px'
      },
      cartNumberCell: {
        textAlign: 'right',
        paddingRight: '30px'
      },
      cartPriceCell: {
        flex: '0 0 250px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 120px'
        },
        [theme.breakpoints.only('lg')]: {
          flex: '0 0 150px'
        }
      },
      cartPriceSubCell: {
        flex: '0 0 200px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 10px'
        },
        [theme.breakpoints.only('lg')]: {
          flex: '0 0 125px'
        }
      },
      cartEventTicketColumn: {
        flex: '1 1 0%',
        background: 'transparent',
        whiteSpace: 'normal',
        lineHeight: 1.5
      },
      subTable: {
        margin: '10px 0px !important',
        '&:last-child': {
          border: 0
        }
      }
    })
  );
